import { render, staticRenderFns } from "./CbsReferenceSelector.vue?vue&type=template&id=60b60ff3&scoped=true"
import script from "./CbsReferenceSelector.vue?vue&type=script&lang=js"
export * from "./CbsReferenceSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b60ff3",
  null
  
)

export default component.exports